import { IOnionMiddleware } from 'umi-request';

export const useBizDataOnly: IOnionMiddleware = async (ctx, next) => {
  await next();

  const { bizDataOnly = true } = ctx.req.options;
  if (bizDataOnly) ctx.res = ctx.res?.data;
};
